<template>
  <div class="main" id="#app">
    <div class="metalsRate">
      <MetalsRate/>
    </div>
    <router-view/>
    <BottomPanel/>
    <ShareCalculation v-if="hasCalculationResult && !isTelegram"/>
    <AnalyticsConsent/>
  </div>
</template>

<script setup>
import MetalsRate from './components/MetalsRate'
import BottomPanel from "@/components/BottomPanel";
import AnalyticsConsent from '@/components/AnalyticsConsent.vue'
import ShareCalculation from '@/components/ShareCalculation.vue'
import {onBeforeUnmount, onMounted, ref, watch} from "vue";
import { useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user/userStore'
import { getTelegramUser, isTelegramWebApp } from '@/helpers/telegram'
const userTg = getTelegramUser()
const isTelegram = isTelegramWebApp()
const user = useUserStore()
const route = useRoute()
const hasCalculationResult = ref(false)

const showShareButton = () => {
  hasCalculationResult.value = true
}

watch(() => route.fullPath, () => {
  hasCalculationResult.value = false
})

onMounted(()=> {
  window.addEventListener('calculator:result', showShareButton)
  if(userTg) {
    user.setUser(userTg)
    user.useAchievement(userTg.id, 1) // 1 - тип входа
  }

})

onBeforeUnmount(() => {
  window.removeEventListener('calculator:result', showShareButton)
})


</script>

<style>
#app {
  font-family: Inter, Helvetica, sans-serif;
  font-weight: 100;
}
.main {
  background: linear-gradient(180deg, #29055F 30%, #5DB7B7 100%);
  /*background:*/
  /*    linear-gradient(to top left, #190042, transparent), !* Градиент снизу слева *!*/
  /*    linear-gradient(to top right, #002685, transparent), !* Градиент снизу справа *!*/
  /*    #7884af;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100vh;
  padding-left: 20px;
  padding-right: 20px;
}
.metalsRate {
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 0.0) !important;
}
* {
  -webkit-tap-highlight-color: transparent;
}
.page-title {
  margin: 0;
  font: inherit;
}
.visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

/* Стили для WebKit-браузеров (Chrome, Edge, Safari) */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 2px solid transparent;
  background-clip: content-box;
  transition: background-color 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

/* Firefox (частичная поддержка, но можно сделать) */
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

</style>
